function isIEDomain (){
	console.log("Domain is ="+window.location.hostname);
	// return true; // to test IE case local, keep it commented
	return window.location.hostname.indexOf('.ie')!=-1
}
export default isIEDomain();
